import { useEffect } from 'react';
import axios from 'axios';
import LocalStorageUtil from './LocalStorageUtil';

const UserLogout = () => {
  const baseHostUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:80';
  useEffect(() => {
    const logout = async () => {
      try {
        await axios.post(`${baseHostUrl}/logout`, {}, {
          withCredentials: true
        });
      } catch (err) {
        console.error("Logout failed:", err);
      } finally {
        LocalStorageUtil.clearSession();  // ✅ Clear local
        window.location.replace('/');
      }
    };

    logout();
  }, []);

  return null;
};

export default UserLogout;